export default {
    to: 'por',
    from: 'de',
    logoAlt: 'Logo do Astrolink',
    bannerGuide2022: '+ Guia 2022',
    highlightGuide2022: 'Antecipe sua leitura do <strong>GUIA 2022</strong>',

    bar: {
        unlock: 'SAIBA MAIS',
        bannerAlt: 'Black Friday 2022'
    },

    comparison: {
        cardOption: 'E mais 10 opções de cartões',
        guide2022: '<strong>Guia 2022</strong> e mais guias'
    },

    selection: {
        chargeSemester: 'Cobrança de R$ {price} por semestre',
    }
};